var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.844 10a.85.85 0 0 0-.065-.322l-.59-1.43a2.484 2.484 0 0 1 1.343-3.242l1.427-.591a.85.85 0 0 0 .458-.456l.59-1.427A2.48 2.48 0 0 1 8.25 1.189l1.426.59c.207.086.44.086.646 0h.002l1.427-.59a2.483 2.483 0 0 1 3.242 1.343l.577 1.393.014.034c.086.207.25.371.457.457l1.427.592a2.48 2.48 0 0 1 1.343 3.241l-.59 1.427a.85.85 0 0 0 0 .648l.59 1.427a2.48 2.48 0 0 1-1.343 3.242l-1.427.59a.85.85 0 0 0-.471.492l-.577 1.393a2.48 2.48 0 0 1-3.242 1.342l-1.427-.588-.002-.001a.85.85 0 0 0-.646 0l-1.426.59a2.48 2.48 0 0 1-3.242-1.343l-.591-1.427a.85.85 0 0 0-.458-.456l-1.427-.591a2.48 2.48 0 0 1-1.343-3.243l.59-1.43A.8.8 0 0 0 1.844 10m11.598-1.467a.818.818 0 0 0-1.157-1.157l-3.103 3.103-1.058-1.058a.818.818 0 0 0-1.157 1.158l1.636 1.636c.32.32.838.32 1.157 0z",
    clipRule: "evenodd"
  })));
};
export default SvgVerified;